<template>
  <div class="preview-viewer preview-wps-viewer" id="wps_frame_div">
    <!-- <iframe ref="wps_frame" v-if="link" id="wps_frame" name="wps_frame"></iframe> -->
  </div>
</template>

<script>
import '../../lib/web-office-sdk-v1.1.19.umd.js'
import ClickDelegate from '../../utils/ClickDelegate.js'
const EVENT_STATE_CHANGED = 'state-changed'

export const WpsState = {
  'SUCCEED': 'SUCCEED',
  'FAILED': 'FAILED'
}

export default {
  name: 'WpsViewer',
  props: {
    previewInfo: Object,
    scenario: String,
    item: Object,
    url: String
  },
  data () {
    let link = this.url
    if (this.scenario) {
      link = `${link}&scenario=${this.scenario}`
    }
    return {
      link,
      timer: null,
      wps_iframe: null
    }
  },
  created () {
    window.addEventListener('message', this.handlePostMessage, false)
  },
  mounted () {
    this.initWps()
  },
  beforeDestroy () {
    window.removeEventListener('message', this.handlePostMessage, false)
    this.wps_iframe && this.wps_iframe.removeEventListener('click', this.clickAction)
  },
  methods: {
    initWps () {
      let iframe = document.getElementById('wps_frame_div')
      if (iframe) {
        const jssdk = window.WebOfficeSDK.config({
          url: this.previewInfo.preview_url,
          mount: iframe,
          wordOptions: {
            mobile: {
              isOpenIntoPagesMode: true
            }
          }
        })
        jssdk.iframe.addEventListener('click', this.clickAction)
        this.wps_iframe = jssdk.iframe
        if (!this.timer) clearTimeout(this.timer)
      } else {
        this.timer = setTimeout(this.initWps(), 0)
      }
    },
    handlePostMessage (msg) {
      const origin = this.previewInfo.preview_url.match(/https?:\/\/[^/]+/)
      if (origin && origin[0] === msg.origin && msg.data.status) {
        if (typeof msg.data === 'object' && msg.data.status === 'fail') {
          this.$emit(EVENT_STATE_CHANGED, WpsState.FAILED)
        } else if (typeof msg.data === 'object' && msg.data.status === 'success') {
          this.$emit(EVENT_STATE_CHANGED, WpsState.SUCCEED)
        }
      }
    },
    clickAction: ClickDelegate.createListener((count) => {
      if (count === 1) {
        this.$emit('onpageclick')
      }
    }).bind(this)
  }
}
</script>

<style lang="postcss">
.preview-wps-viewer {
  & iframe {
    flex: 1 1 auto;
    width: 100%;
    height: 100%;
    border: 0;
  }
}
</style>
